import React  from 'react';
import {
    Box,
    Button,
    Typography
} from "@material-ui/core";
import CustomTable from "../customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import {useEffect, useState} from "react";
import AddNewElections from "../AddNewElections/AddNewElections";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {ElectionService} from "./ElectionService";
import moment from "jalali-moment";
import ElectionInfo from "../electionInfo/ElectionInfo";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";


let page = 0
let selectedItemId = -1
const Election = ({isMain = true,}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new ElectionService(fundID, token, snackbar, loading)
    //fund-presentation/funds/5/elections

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }
    }, [])


    const [itemCount, setItemCount] = useState(25);
    const [pageCount, setPageCount] = useState(5);

    const [electionList, setElectionList] = useState([]);

    const [needRefresh, setNeedRefresh] = useState(false);

    const handleChange = (event, value) => {
        page = value - 1
        getDataFromServer()
    };

    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))

        service.getElectionList(fundID, page)
            .then(response => {

                setElectionListData(response)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason,"خطا در دریافت لیست انتخابات",snackbar,loading)
        })
    }


    function setElectionListData(data) {

        setItemCount(data.numberOfItems)
        setPageCount(data.totalPage)
        setElectionList([])

        data.data.map((item, index) => {
            setElectionList(prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.title,
                    item.startPersianDate,
                    item.startPersianTime,
                    item.endPersianDate,
                    item.endPersianTime,
                    item.groupName,
                    item.published,
                    item.enabled
                )
            ])
        })

    }


    function prepareGroupsJsonList(id, number, title, startPersianDate, startTime, endPersianDate, endTime, groupName, published, enabled) {
        return {
            id: id,
            number: number,
            title: title,
            startDate: startPersianDate,
            startTime: startTime,
            endDate: endPersianDate,
            endTime: endTime,
            groupName: groupName,
            published: published ? <span className="bg_active_state">منتشر شده</span> :
                <span className="bg_deActive_state">در انتظار انتشار</span>,
            state: enabled ? <span className="bg_active_state">فعال</span> :
                <span className="bg_deActive_state">بسته شده</span>,
        }

    }


    const showEventsContent = (rowId) => {
        selectedItemId = rowId
        setOpenInfoDialog(true)
    }
    // dialog-start
    const [openDialog, setOpenDialog] = useState(false);

    const [openInfoDialog, setOpenInfoDialog] = useState(false);

    const handleClickOpen = () => {
        setNeedRefresh(false)
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
        selectedItemId = -1
        if (needRefresh)
            getDataFromServer()
    };

    const handleClickOpenElectionInfo = () => {
        setNeedRefresh(false)
        setOpenInfoDialog(true);
    };

    const handleCloseElectionInfo = () => {
        setOpenInfoDialog(false);
        selectedItemId = -1
        if (needRefresh)
            getDataFromServer()
    };

    // dialog-end
    return (
        <>
            {
                <>
                    <AddNewElections
                        openDialog={openDialog}
                        handleClickOpen={handleClickOpen}
                        handleClose={handleClose}
                        needRefresh={setNeedRefresh}
                        selectedItemId={selectedItemId}
                    />
                    <ElectionInfo
                        openDialog={openInfoDialog}
                        handleClickOpen={handleClickOpenElectionInfo}
                        handleClose={handleCloseElectionInfo}
                        needRefresh={setNeedRefresh}
                        selectedItemId={selectedItemId}
                    />
                </>
            }
            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className={`${isMain ? "d-flex flex-row w-100" : "d-none"}`}
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            لیست انتخابات
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " عضو ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                    <Button
                        className={`${isMain ? "d-block" : "d-none"}`}
                        variant='contained'
                        onClick={() => {
                            selectedItemId = -1
                            setOpenDialog(true)
                            // setOpenDialog(true);
                        }}
                        // startIcon={<DeleteIcon/>}
                    >
                        افزودن انتخابات جدید
                    </Button>
                </Box>


                <CustomTable
                    header={columns}
                    data={electionList}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>
    )
}

export default Election;

const columns = [
    {id: 'number', label: '#', align: 'right'},
    {id: 'title', label: 'عنوان', align: 'right'},
    {id: 'startDate', label: 'تاریخ شروع', align: 'right'},
    {id: 'startTime', label: 'زمان شروع', align: 'right'},
    {id: 'endDate', label: 'تاریخ پایان', align: 'right'},
    {id: 'endTime', label: 'زمان پایان', align: 'right'},
    {id: 'groupName', label: 'گروه', align: 'right'},
    {id: 'published', label: 'وضعیت انتشار', align: 'right'},
    {id: 'state', label: 'وضعیت', align: 'right'},
];
